import { inject as J } from "vue";
function e(n, r) {
  return r ? Object.keys(r).reduce(
    (t, a) => t.replace(`{${a}}`, r[a].toString()),
    n
  ) : n;
}
const K = Symbol("i18n"), X = () => J(K, {
  t: (n, r) => e(n, r) || n,
  tc: (n, r, t) => e(n, t) || n
});
var s;
(function(n) {
  n.ApplyDiscount = "apply-discount", n.Dismiss = "dismiss", n.Engage = "engage", n.Hide = "hide", n.NoAction = "no-action", n.Fallback = "none", n.GenericLinkClick = "generic-link-click", n.LoadScript = "load-script", n.OpenBookingEngine = "open-be", n.OpenUri = "open-uri", n.PredictiveAudience = "predictive-audience", n.SendForm = "send-form", n.SendSaveSearch = "send-save-search", n.SendSiteContact = "send-site-contact", n.SendSubscribe = "send-subscribe", n.Show = "show", n.Login = "login", n.TranslateDocumentBody = "translate-document-body";
})(s || (s = {}));
var c;
(function(n) {
  n.Resend = "resend", n.Signup = "signup", n.Signin = "signin", n.Validation = "validation";
})(c || (c = {}));
var l;
(function(n) {
  n.Arabic = "ar", n.Basque = "eu", n.Bulgarian = "bg", n.Catalan = "ca", n.Chinese = "zh", n.ChineseTraditional = "zh-TW", n.Croatian = "hr", n.Czech = "cs", n.Danish = "da", n.Deutsch = "de", n.Dutch = "nl", n.English = "en", n.Estonian = "et", n.Finnish = "fi", n.French = "fr", n.Greek = "el", n.Hebrew = "he", n.Hungarian = "hu", n.Icelandic = "is", n.Indonesian = "id", n.Italian = "it", n.Japanese = "ja", n.Korean = "ko", n.Lithuanian = "lt", n.Norwegian = "no", n.Polish = "pl", n.Portuguese = "pt", n.Romanian = "ro", n.Russian = "ru", n.Slovenian = "sl", n.Spanish = "es", n.Swedish = "sv", n.Thai = "th", n.Turkish = "tr", n.Ukrainian = "uk", n.Vietnamese = "vi";
})(l || (l = {}));
var u;
(function(n) {
  n.Timing = "timing", n.Oraculo = "oraculo", n.VisitorProfile = "visitorProfile", n.VisitorBehaviour = "visitorBehaviour", n.Search = "search", n.TravelParty = "travelParty", n.DataVariables = "dataVariables", n.Demand = "demand", n.Integrations = "integrations";
})(u || (u = {}));
var d;
(function(n) {
  n.Exclude = "exclude", n.Include = "include";
})(d || (d = {}));
var g;
(function(n) {
  n.Any = "any", n.Is = "is", n.Are = "are", n.IsBetween = "isBetween", n.AreBetween = "areBetween", n.IsLower = "isLower", n.AreLower = "areLower", n.IsHigher = "isHigher", n.IsGreater = "isGreater", n.AreGreater = "areGreater", n.IsBefore = "isBefore", n.AreBefore = "areBefore", n.IsAfter = "isAfter", n.AreAfter = "areAfter", n.Contain = "contain";
})(g || (g = {}));
var f;
(function(n) {
  n.Is = "is", n.IsNot = "isNot", n.AnyValue = "anyValue", n.NotAnyValue = "notAnyValue", n.Lower = "lower", n.Greater = "greater", n.Contains = "contains", n.NotContains = "notContains";
})(f || (f = {}));
var p;
(function(n) {
  n.Registered = "registered", n.NonRegistered = "non_registered", n.RegisteredAndLogged = "registered", n.NotRegisteredAndNotLogged = "non_registered_nor_logged", n.RegisteredOrLogged = "registered_all", n.RegisteredAndNotLogged = "registered_non_logged", n.NotLogged = "non_registered";
})(p || (p = {}));
var v;
(function(n) {
  n.Logged = "logged", n.NonLogged = "nonLogged";
})(v || (v = {}));
var m;
(function(n) {
  n.Any = "any", n.First = "first", n.All = "all", n.Search = "search", n.Booked = "booked", n.Custom = "custom";
})(m || (m = {}));
var h;
(function(n) {
  n.Colors = "colors", n.Fonts = "fonts", n.Button = "button", n.SecondaryButton = "secondaryButton", n.Background = "background", n.Overlay = "overlay";
})(h || (h = {}));
var y;
(function(n) {
  n.None = "none", n.Uppercase = "uppercase", n.Lowercase = "lowercase", n.Titlecase = "titlecase";
})(y || (y = {}));
var S;
(function(n) {
  n.Google = "google", n.File = "file", n.Regular = "regular";
})(S || (S = {}));
var L;
(function(n) {
  n.Custom = "custom", n.Square = "square", n.Medium = "medium", n.Rounded = "rounded";
})(L || (L = {}));
var _;
(function(n) {
  n.Percentage = "%", n.Pixels = "px", n.Rem = "rem", n.Em = "em";
})(_ || (_ = {}));
var b;
(function(n) {
  n.Solid = "solid", n.Outline = "outline";
})(b || (b = {}));
var w;
(function(n) {
  n.Url = "url", n.DefaultText = "default_text", n.CustomText = "custom_text", n.NotLinked = "not_linked", n.CustomUrl = "custom_url";
})(w || (w = {}));
var i;
(function(n) {
  n.NowViewing = "nowViewing", n.TodayViewed = "todayViewed", n.BookedToday = "bookedToday", n.LastReservation = "lastReservation", n.DiscountToday = "discountToday", n.TodaySpecialOffer = "todaySpecialOffer";
})(i || (i = {}));
var R;
(function(n) {
  n.ApplyPromoCode = "apply_promo_code", n.OpenUrl = "open_url", n.OpenMailClient = "open_mail_client", n.CallPhoneNumber = "call_phone_number", n.CloseTool = "close_tool", n.EmailCapture = "email_capture", n.SavedSearch = "saved_search", n.GoMainStep = "go_main_step", n.SendForm = "form", n.OpenBookingEngine = "send_to_be", n.Submit = "submit", n.LastSearch = "send_to_last_search";
})(R || (R = {}));
var C;
(function(n) {
  n.Default = "default", n.Coupon = "coupon", n.Rate = "rate", n.Corporative = "corpo", n.Group = "group";
})(C || (C = {}));
var T;
(function(n) {
  n.Primary = "primary", n.Secondary = "secondary";
})(T || (T = {}));
var k;
(function(n) {
  n.Note = "note", n.Layer = "layer", n.Exit = "exit", n.Inliner = "inliner";
})(k || (k = {}));
var B;
(function(n) {
  n.Success = "success", n.Failure = "failure", n.Main = "main";
})(B || (B = {}));
var A;
(function(n) {
  n.LoginSignin = "login-signin", n.LoginRegister = "login-register", n.LoginSuccess = "login-success";
})(A || (A = {}));
var I;
(function(n) {
  n.Activity = "activity", n.Button = "button", n.Countdown = "countdown", n.EmailCapture = "emailCapture", n.Form = "form", n.Heading = "heading", n.ImageWithBehaviour = "imageWithBehaviour", n.Icon = "icon", n.Paragraph = "paragraph", n.Perks = "perks", n.SavedSearch = "savedSearch", n.Spacer = "spacer", n.Login = "login";
})(I || (I = {}));
var o;
(function(n) {
  n.None = "none", n.WebExclusive = "web_exclusive", n.SubjectToAvailibity = "subject_to_availability", n.OnlyForSpecificRates = "only_for_specific_rates", n.OnlyForRegisterdUsers = "only_for_registered_users";
})(o || (o = {}));
var N;
(function(n) {
  n.Bullets = "bullets", n.Highlights = "highlights";
})(N || (N = {}));
var O;
(function(n) {
  n.None = "none", n.Solid = "solid", n.Outline = "outline";
})(O || (O = {}));
var P;
(function(n) {
  n.Normal = "normal", n.Compact = "compact";
})(P || (P = {}));
var V;
(function(n) {
  n.Date = "date", n.Time = "time";
})(V || (V = {}));
var x;
(function(n) {
  n.Visitor = "visitor", n.Hotel = "hotel";
})(x || (x = {}));
var D;
(function(n) {
  n.Out = "out", n.Inside = "inside";
})(D || (D = {}));
var F;
(function(n) {
  n.Single = "single", n.Multiple = "multiple";
})(F || (F = {}));
var M;
(function(n) {
  n.ShortText = "shortText", n.Email = "email", n.Phone = "phone", n.Date = "date", n.LongText = "longText", n.DropDown = "dropdown", n.Selection = "selection";
})(M || (M = {}));
var U;
(function(n) {
  n.Top = "T", n.Bottom = "B", n.Left = "L", n.Right = "R", n.UpperLeft = "UL", n.UpperRight = "UR", n.UpperMidLeft = "UML", n.UpperMidRight = "UMR", n.LowerMidLeft = "LML", n.LowerMidRight = "LMR", n.LowerLeft = "LL", n.LowerRight = "LR";
})(U || (U = {}));
var E;
(function(n) {
  n.Mobile = "mobile", n.Desktop = "desktop";
})(E || (E = {}));
var G;
(function(n) {
  n.EveryPage = "on_every_page", n.OncePerVisit = "once_per_visit", n.OncePerVisitor = "once_per_visitor", n.OncePerProperty = "once_per_property", n.OncePerBrand = "once_per_brand";
})(G || (G = {}));
var H;
(function(n) {
  n.Load = "load", n.Scroll = "scroll", n.Idle = "idle";
})(H || (H = {}));
var q;
(function(n) {
  n.Regular = "regular", n.Compact = "compact";
})(q || (q = {}));
var j;
(function(n) {
  n.Single = "single", n.Multi = "multi";
})(j || (j = {}));
var W;
(function(n) {
  n.Bar = "bar", n.Circular = "circular", n.CustomImage = "custom-image", n.Fullscreen = "full-screen", n.FullscreenMini = "full-screen-mini", n.LowerNotification = "lower-notification", n.NotificationTab = "notification-tab", n.Sidebar = "sidebar", n.SideGradient = "side-gradient", n.SlideIn = "slide-in", n.Square = "square", n.SquareImage = "square-image", n.Sticky = "sticky", n.StickyImage = "sticky-image";
})(W || (W = {}));
var z;
(function(n) {
  n.Left = "left", n.Center = "center", n.Right = "right";
})(z || (z = {}));
var $;
(function(n) {
  n.Inline = "inline", n.Overlay = "overlay";
})($ || ($ = {}));
i.NowViewing + "", i.TodayViewed + "", i.BookedToday + "", i.LastReservation + "", i.DiscountToday + "", i.TodaySpecialOffer + "";
o.None + "", o.SubjectToAvailibity + "", o.WebExclusive + "", o.OnlyForRegisterdUsers + "", o.OnlyForSpecificRates + "";
export {
  X as p
};
//# sourceMappingURL=widgets-core.es.DdX21Kyh.js.map
